import { defineModule } from '../utils/helpers';

const getElements = () => ({
  talentFilterButtons: document.querySelectorAll<HTMLButtonElement>(
    '#talents button[data-href]',
  ),
});

export default defineModule(() => {
  const { talentFilterButtons } = getElements();

  talentFilterButtons.forEach((btn) =>
    btn.addEventListener('click', () => {
      const url = btn.dataset.href;
      if (!url) return;

      window.location.href = url;
    }),
  );
});
